/** @format */

import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ModelMapper } from 'model-mapper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { File } from '../classes/file';
import { buildHeaderSearchFilter, IHeaderSearch } from '../classes/header-search';
import { Order, OrderStatus } from '../classes/order';
import { LibConfig, LibConfigService } from '../config.service';

export interface IOrderFilter extends IHeaderSearch {
  statuses?: OrderStatus[];
  year?: number;
  realEstateStructureId?: string;
  withInterventionReport?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  constructor(@Inject(LibConfigService) protected config: LibConfig, protected http: HttpClient) {}

  public get(id: string): Observable<Order> {
    return this.http
      .get<any[]>(`${this.config.environment.apiUrl}/orders/${id}`)
      .pipe(map(data => new ModelMapper(Order).map(data)));
  }

  public setStatus(
    id: string,
    data: { status: OrderStatus; interventionDate?: Date; interventionReport?: File; date?: Date }
  ): Observable<boolean> {
    return this.http.patch<boolean>(`${this.config.environment.apiUrl}/orders/${id}/set-status`, data);
  }

  public cancel(id: string): Observable<boolean> {
    return this.http.patch<boolean>(`${this.config.environment.apiUrl}/orders/${id}/cancel`, {});
  }

  protected buildSearchFilter(search: IOrderFilter): any {
    const filter: any = buildHeaderSearchFilter(search);
    if (search?.statuses?.length) filter.statuses = search.statuses;
    if (search?.year) filter.year = search.year;
    if (search?.realEstateStructureId) filter.realEstateStructureId = search.realEstateStructureId;
    if (search?.withInterventionReport === true) filter.withInterventionReport = true;
    return filter;
  }
}
